<template>
  <BaseModal id="modal-delete-criteria" title="Delete this criteria" :show.sync="$show">
    <p class="text-black-50">Are you sure that you want to delete this criteria?</p>
    <b-alert variant="danger" show>{{ title }}</b-alert>
    <p class="text-black-50">Click at the “Delete” button to delete this criteria.</p>
    <template #modal-footer>
      <div class="d-flex justify-content-end w-100">
        <b-button
          id="button-cancel"
          variant="link"
          class="btn-link-dark"
          :disabled="disabled"
          @click="hide()"
        >
          Cancel
        </b-button>
        <b-button id="button-delete" variant="danger" :disabled="disabled" @click="handleDelete()">
          <b-spinner v-if="submitting" />
          <span v-else> Delete</span>
        </b-button>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import { BaseModal } from '@/components/base-components';
import { Criteria } from '@/models/Criteria';
import { LearningOutcome } from '@/models/LearningOutcome';
export default {
  components: {
    BaseModal
  },

  props: {
    ultimateLearningOutcome: {
      type: LearningOutcome,
      required: true
    },

    criteria: {
      type: Criteria,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      title: '',
      disabled: false,
      submitting: false
    };
  },

  computed: {
    $show: {
      get() {
        return this.show;
      },

      set(v) {
        this.$emit('update:show', v);
      }
    },
    defaultLearningOutcome() {
      return LearningOutcome.find(this.criteria.learning_outcome_id);
    }
  },

  watch: {
    show: {
      immediate: true,
      handler(show) {
        if (show) {
          this.title = this.criteria ? this.criteria.title : '';
        }
      }
    }
  },

  methods: {
    async handleDelete() {
      try {
        this.disabled = true;
        this.submitting = true;

        if (this.criteria) {
          const { id, learning_outcome_id } = this.criteria;

          if (this.defaultLearningOutcome) {
            const criterion_ids = this.defaultLearningOutcome.criterion_ids.filter(
              (criterion_id) => criterion_id != id
            );

            LearningOutcome.update({
              where: this.defaultLearningOutcome.id,
              data: {
                criterion_ids: criterion_ids
              }
            });
          }

          let { properties = '{}' } = this.ultimateLearningOutcome;

          properties = JSON.parse(properties);

          const { order = [] } = properties;

          if (this.defaultLearningOutcome.id == this.ultimateLearningOutcome.id) {
            const orderIndex = order.findIndex(
              (subOrder) => subOrder.id == id && subOrder.model == 'criterias'
            );

            if (orderIndex !== -1) {
              order.splice(orderIndex, 1);
            }
          } else {
            const orderIndex = order.findIndex((subOrder) => subOrder.id == learning_outcome_id);

            if (orderIndex !== -1) {
              const subOrder = order[orderIndex];

              if (subOrder) {
                const { children = [] } = subOrder;

                const childrenIndex = children.findIndex((child) => {
                  return child.id == id;
                });

                if (childrenIndex !== -1) {
                  children.splice(childrenIndex, 1);

                  this.$set(order[orderIndex], 'children', children);
                }
              }
            }
          }

          await LearningOutcome.api().updateProperties(this.ultimateLearningOutcome.id, {
            ...properties,
            order
          });

          await Criteria.api().destroy(id);

          this.$emit('onCriteriaDeleted', id);
        } else {
          this.$toast.error(`Cannot delete criteria`);
        }
        this.$toast.success(`The criteria was deleted successfully`);
        this.hide();
      } catch (error) {
        this.disabled = false;

        this.$toast.error(`Cannot delete criteria`);
      } finally {
        this.disabled = false;
        this.submitting = false;
      }
    },
    hide() {
      this.$bvModal.hide(`modal-delete-criteria`);
    }
  }
};
</script>

<style lang="scss" scoped></style>
